<template>
  <div>
    <div class="header bg-gradient-success pb-6 pb-8 pt-5 pt-md-8">

      <h4 class="profile-section-title"><i class="ni ni-badge"></i> لیست کانترها </h4>
    </div>
    <div class="container-fluid mt--7">
      <div class="card ">
        <section id="section-1" class="">
          <div style="text-align: center" class="col-md-12 loading" v-if="isLoading">
            <loadingBar type="ripple" />
          </div>
          <div v-else>
            <div class="row" style="margin-bottom: 15px">
              <div class="col-md-11"></div>
              <div class="col-md-1 close-btn">
                <router-link to="/profile/dashboard">
                  <div title="بازگشت به داشبورد" class="close"></div>
                </router-link>
              </div>
            </div>
            <div class="row" style="margin-bottom: 20px">
              <div class="col-lg-9"></div>
              <div class="col-lg-3">
                <router-link class="btn btn-primary" to="/profile/createCounter">افزودن کانتر</router-link>
              </div>
            </div>

            <div class="row rtl">
              <div class="col-lg-10"></div>
              <div class="col-lg-3 add-btn"></div>
            </div>
            <div id="tools" style="margin-top: -30px">
              <div class="pd0 col btn-group">
                <button type="button" class="
              the-icons
              btn 
              btn-style-group
              border-left
              col-lg-2 col-md-2
              text-view
            ">
                  نام کانتر
                </button>
                <button type="button" class="
              the-icons
              btn btn-style-group
              border-left
              col-lg-2 col-md-2
              text-view
            ">
                  کسب و کار
                </button>
                <button type="button" class="
              the-icons
              btn btn-style-group
              border-right
              col-lg-2 col-md-2
              text-view
            ">
                  ایمیل
                </button>
                <button type="button" class="the-icons btn btn-style-group col-lg-2 col-md-2 border-right">
                  وضعیت
                </button>

                <button type="button" class="
              the-icons
              btn btn-style-group
              border-left
              col-lg-4 col-md-4
              text-view
              border-right
            ">
                  افزودن نقش
                </button>
              </div>
            </div>

            <div class="strip_booking" v-for="(counter, index) in counterList" :key="index">
              <div class="row">
                <div class="col-lg-2 col-md-2 text-view">
                  <strong>{{ counter.counterName }} </strong>
                </div>

                <div class="col-lg-2 col-md-2 text-view">
                  {{ counter.businessName }}
                </div>
                <div class="col-lg-2 col-md-2 text-view">
                  {{ counter.email }}
                </div>

                <!-- <div class="col-lg-2 col-md-2 text-view date-vertical">
            {{ counter.createdDate | persianDate("jYYYY/jMM/jDD") }}
          </div> -->
                <div class="col-lg-2 col-md-2 text-view">
                  <div class="booking_buttons">
                    <label class="switch">
                      <input style="display: none" id="switch" type="checkbox"
                        @click="toggleCheckbox(counter.status, counter.profileId)" v-model="counter.status" />
                      <div class="SliderSwitch__container">
                        <div class="SliderSwitch__toggle"></div>
                      </div>
                    </label>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 text-view">
                  <i class="icon-user-add i-user-add" @click="loadCounterRoleDialog(counter)"></i>
                </div>
                <!-- End row -->
              </div>
            </div>
          </div>
          <!-- assign role to counter -->
          <transition name="modal" v-if="showMessageDialog">
            <assign-role-to-counter :counterId="profileId" :counterName="counterName" @closeDialog="closeDialog" />
          </transition>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store/index";
import loadingBar from "../../../components/loading/pdkLoadingBar";
import AssignRoleToCounter from "../../../components/profile/AssignRoleToCounterDialog";

export default {
  name: "UserBusinessList",
  store,
  components: {
    loadingBar,
    AssignRoleToCounter,
  },
  data() {
    return {
      relatedProfileId: "",
      profileId: "",
      counterName: "",
      sortType: "",
      isLoading: false,
      counterList: [],
      checkbox: false,
      showMessageDialog: false,
    };
  },
  mounted() {
    this.loadList();
  },
  created() { },
  methods: {
    async loadList() {
      this.isLoading = true;
      this.counterList = await this.$store.dispatch(
        "getCounterList",
        localStorage.getItem("UserId")
      );

      this.isLoading = false;
    },
    async toggleCheckbox(status, profileId) {
      let changeStatus = 4;
      if (status != false) changeStatus = 3;
      else changeStatus = 4;

      const res = await this.$store.dispatch("changeProfileStatus", {
        profileId: profileId,
        status: changeStatus,
      });

      if (res.status == 200) {
        // alert("وضعیت با موفقیت به روز رسانی گردید");
        this.$toast.success("وضعیت با موفقیت به روز رسانی گردید", {
          position: "top-center",
          timeout: 4500,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 1.59,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          icon: true,
          rtl: true,
        });

      }
    },
    loadCounterRoleDialog(row) {
      this.profileId = row.profileId;
      this.counterName = row.counterName;
      this.showMessageDialog = true;
    },
    closeDialog() {
      this.showMessageDialog = false;
    },
  },
};
</script>

<style scoped>
.strip_booking {
  border-bottom: 1px solid #ededed;
  padding-bottom: 15px;
  margin-bottom: 15px;
}

ul.info_booking {
  padding: 15px 0 15px 25px;
  border-right: 0;
  border-left: 1px solid #ededed;
  text-align: left;
  font-size: 11px;
  color: #999;
  line-height: 12px;
}

a.btn_2,
.btn_2,
a.btn_3,
.btn_3 {
  font-family: inherit;
  font-size: 15px !important;
  color: #162949;
  background: rgb(230, 168, 27);
  background: linear-gradient(67deg, rgba(230, 168, 27, 1) 0%, rgba(255, 197, 64, 1) 100%);
  cursor: pointer;
  padding: 15px 8px;
  font-size: 11px;
  line-height: 9px;
  display: block;
  outline: none;
  transition: all 0.3s;
  border-radius: 36px;
  text-align: center;
}

.add-btn {
  text-align: center;
  left: 0 !important;
  margin: 0px 0px 30px 0px !important;
}

a.btn_3:hover,
.btn_3:hover {
  background: #333;
  color: #fff;
}

a.btn_3,
.btn_3 {
  color: #999;
  background: #eee;
  min-width: 60px;
  text-align: center;
  margin-top: 3px;
}

.text-view {
  text-align: center !important;
}

.date-vertical {
  border-left: 1px solid #ededed;
  text-align: center !important;
  margin-right: 11px;
}

.headr-list {
  font-size: 16px;
  color: #151414;
  margin-top: 5px;
  height: 34px;
}

.heafer-icon {
  float: left !important;
  text-align: left !important;
  font-size: 28px;
  color: #008489 !important;
  margin-top: 5px;
}

.booking_buttons {
  margin: 0px 30px 0px 30px;
}
</style>

<style scoped>
.SliderSwitch {
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;

  text-align: center;
}

.SliderSwitch input {
  visibility: hidden;
  display: inline-block;
  width: 1px;
  height: 1px;
}

.SliderSwitch label {
  font-family: Helvetica, Arial, sans-serif;
  cursor: pointer;
}

.SliderSwitch__container {
  background-color: #ff0000;
  height: 20px;
  display: inline-block;
  width: 50px;
  border-radius: 10px;
  position: relative;
  vertical-align: middle;
  box-shadow: inset 0px 0px 3px 1px rgba(0, 0, 0, 0.3);
  margin-left: 10px;

  transition: background-color 300ms ease-in-out;
}

.SliderSwitch__toggle {
  display: block;
  height: 24px;
  width: 24px;
  border-radius: 12px;
  background-color: white;
  border: 1px solid #ddd;
  position: absolute;
  top: -2px;
  left: -2px;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.2);
  cursor: pointer;

  transition: left 300ms ease-in-out;
}

.SliderSwitch__toggle:after {
  content: "\f00d";
  font-family: "FontAwesome";
  font-size: 12px;
  color: #ff4136;
  display: block;
  position: absolute;
  top: 35%;
  margin-top: -6px;
  left: 0;
  width: 100%;
  text-align: center;

  transition: color 300ms ease-in-out;
}

input:checked+.SliderSwitch__container {
  background-color: #01ff70;
}

input:checked+.SliderSwitch__container .SliderSwitch__toggle {
  left: calc(100% - 20px);
}

input:checked+.SliderSwitch__container .SliderSwitch__toggle:after {
  content: "\f00c";
  color: #2ecc40;
}

.i-user-add {
  font-size: 25px;
  color: #208cfa;
  cursor: pointer;
}
</style>